// extracted by mini-css-extract-plugin
export default {"centered":"TableProductBody_centered__8C+Pz","message":"TableProductBody_message__G--6F"};